module.exports = __webpack_public_path__ + "img/portrait-pom-old.be1b6c1.jpg";